import { render, staticRenderFns } from "./SortBtn.vue?vue&type=template&id=5c5922dc&scoped=true"
import script from "./SortBtn.vue?vue&type=script&lang=js"
export * from "./SortBtn.vue?vue&type=script&lang=js"
import style0 from "./SortBtn.vue?vue&type=style&index=0&id=5c5922dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5922dc",
  null
  
)

export default component.exports